import {
     Button,
     Card,
     Dropdown,
     DropdownItem,
     DropdownMenu,
     DropdownToggle,
     Input,
     Table,
   } from "reactstrap";
   import Breadcrumbs from "../../coreComponents/breadcrumbs";
   import CommonCardHeader from "../../coreComponents/CommonCardHeader";
   import { useEffect, useState } from "react";
   import DateTimePicker from "react-datepicker";
   import Select, { components, MultiValue } from "react-select";
   import ApiService from "../../services/apiService";
   import { toast } from "react-toastify";
   import { method } from "lodash";
   import AddIcon from "../svg/AddIcon";
   import EditIcon from "../svg/EditIcon";
   import DeleteIcon from "../svg/DeleteIcon";
   import { format } from "date-fns";
   type Option = { label: string; value: number };
   type RowData = {
     id?: number;
     schno: number;
     enabled: boolean;
     startDate: Date | null;
     endDate: Date | null;
     startTime: Date | null;
     duration: string;
     weekdaysBit: string;
     valvesBit: string;
     selectedDays: Option[];
     selectedValves: Option[] | Option | null;
     volume:string | null;
     totalChakCount: number | null;
     eraseRetry:number
   };
   
   const TOTAL_VALVES = 14;
   
   const weekdayOptions: Option[] = [
     { label: "Mon", value: 6 },
     { label: "Tue", value: 5 },
     { label: "Wed", value: 4 },
     { label: "Thu", value: 3 },
     { label: "Fri", value: 2 },
     { label: "Sat", value: 1 },
     { label: "Sun", value: 0 },
   ];
   const pfCmdOptions: Option[] = [
     { label: "PFCMD 1", value: 1 },
     { label: "PFCMD 2", value: 2 },
     { label: "PFCMD 3", value: 3 },
     { label: "PFCMD 4", value: 4 },
   ];
   
   const valveOptions: Option[] = Array.from({ length: TOTAL_VALVES }, (_, i) => ({
     label: `V${i + 1}`,
     value: i + 1,
   }));
   
   const bitToOptions = (bitSeq: string, options: Option[]) => {
     console.log(bitSeq);
     const bits = bitSeq.split("").map((b) => b === "1");
     // Ignore the first padding bit (index 0)
     const daysBits = bits.slice(1);
     return options.filter((opt) => daysBits[opt.value]);
   };
   const bitToValve = (bitSeq: string, options: Option[]) => {
     const bits = bitSeq
       .padStart(14, "0")
       .split("")
       .map((b) => b === "1");
   
     // Map bits back to valve options
     return options.filter((opt) => {
       const bitIndex = 14 - opt.value; // V1 → index 7, V2 → index 6, ...
       return bits[bitIndex];
     });
   };
   console.log(bitToValve)
   const decimalToBitString = (num: number, length: number = 14): string => {
     return num.toString(2).padStart(length, "0");
   };
   console.log(decimalToBitString);
   const epochToDate = (epoch: number | null) => (epoch ? new Date(epoch * 1000) : null);
   
   const MultiValueContainer = (props: any) => {
     const selected = props.getValue();
     return (
       <components.ValueContainer
         {...props}
         title={selected.map((s: any) => s.label).join(", ")}
       >
         {props.children}
       </components.ValueContainer>
     );
   };
   interface ChakCountResponse {
    totalChakCount: number;
  }
   const GroupScheduler = () => {
    let pollingInterval: NodeJS.Timeout | null = null;
  let pollingTimeout: NodeJS.Timeout | null = null;

  type ProgressMode = "RETRY" | "DELETE";
  let currentProgressMode: ProgressMode | null = null;

  const POLLING_INTERVAL = 5000;
  const TICK = 500;
  const POLLING_DURATION = 15_000; // 25 seconds
  // update every 250ms (smooth)
  let retryToastId: any = null;
  let progressInterval: any = null;
  let startTime = 0;
 
      const [retry, setRetry] = useState<number>(0);
     const [chakCount, setChakCount] = useState<ChakCountResponse | null>(null);
     const [rows, setRows] = useState<RowData[]>([]);
     const [modifiedRows, setModifiedRows] = useState<RowData[]>([]);
     const [groupData, setGroupData] = useState<any[]>([]);
     const [selectedGroup, setSelectedGroup] = useState<string>("");
     const [selectedGroupId, setSelectedGroupId] = useState<number | string>();
     const [collapsed, setCollapsed] = useState(false);
     const [secondDropdown, setSecondDropdown] = useState(false);
     const [thirdDropdown, setThirdDropdown] = useState<{
       [key: number]: boolean;
     }>({});
     const [retryMap, setRetryMap] = useState<Record<number, number>>({});
    
     const [nodeScheduler, setNodeScheduler] = useState<any[]>();
    
     const [deviceType, setDeviceType] = useState<string>("");
   
     const toggleDropdown2 = () => setSecondDropdown(!secondDropdown);
    
     const updateRow = (id: number, key: keyof RowData, value: any) => {
       setRows((prev) =>
         prev.map((r) => (r.schno === id ? { ...r, [key]: value } : r))
       );
   
       setModifiedRows((prev) => {
         const existing = prev.find((r) => r.schno === id);
         const baseRow = rows.find((r) => r.schno === id);
         if (!baseRow) return prev;
         const updatedRow = { ...baseRow, [key]: value };
         if (existing) return prev.map((r) => (r.schno === id ? updatedRow : r));
         return [...prev, updatedRow];
       });
     };

     const startProgressBar = () => {
      startTime = Date.now();
  
      progressInterval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / POLLING_DURATION, 1);
        let label = "";
        if (currentProgressMode === "RETRY") {
          label = `Retry in progress... ${Math.round(progress * 100)}%`;
        } else if (currentProgressMode === "DELETE") {
          label = `Deleting schedule... ${Math.round(progress * 100)}%`;
        }
        toast.update(retryToastId, {
          progress,
          render: label,
        });
  
        if (progress >= 1) {
          clearInterval(progressInterval!);
        }
      }, TICK);
    };
  
    const forceScheduleDelete = async(scheduleId:string|number)=>{
       try{
          const response = await ApiService.axiosApi(`/schedulemaster/deletebyscheduleid/${scheduleId}`,{
             method:"DELETE"
          })
  
          if(response.success){
            getSchedule();
            getChakCount();
             toast.success("Deleted schedule successfully")
          }else{
             toast.error("Failed to delete schedule")
          }
       }catch(e){
         console.error(e)
       }
    }
  
    const startSchedulerCheck = () => {
      const interval = setInterval(() => {
        getSchedule();
      }, 5000); // run every 5 seconds
  
      // Stop after 25 seconds
      setTimeout(() => {
        clearInterval(interval);
      }, 15000);
    };
    const checkTotalCount = () =>{
     
      const interval = setInterval(() => {
        getChakCount();
      }, 5000); // run every 5 seconds
  
      // Stop after 25 seconds
      setTimeout(() => {
        clearInterval(interval);
      }, 15000);
    }
  
    const getChakCount = async () => {
      try {
        const response = await ApiService.axiosApi(
          `/schedulemaster/getchakcount/${selectedGroupId}`,
          {
            method: "GET",
          }
        );
  
        if (response.success) {
          setChakCount(response.data);
        } else {
          console.error("unable to get chak count");
        }
      } catch (e) {
        console.error(e);
      }
    };
  
    useEffect(() => {
      getChakCount();
    }, [selectedGroupId]);
  
    const deleteSchedule = async (
      groupId: number | string,
      scheduleId: number | string
    ) => {
      currentProgressMode = "DELETE";
      retryToastId = toast.loading("Deleting schedules...", {
        closeOnClick: false,
        draggable: false,
      });
      try {
        const response = await ApiService.axiosApi(
          `/schedulemaster/Erase${groupId}/${scheduleId}`,
          {
            method: "POST",
          }
        );
        if (response.success) {
          startProgressBar();
          startSchedulerCheck();
        } else {
          console.log("schedule not deleted");
        }
      } catch (e) {
        console.log(e);
      }
    };
  
    const deleteAllSchedule = async () => {
      currentProgressMode = "DELETE";
      retryToastId = toast.loading("Deleting schedules...", {
        closeOnClick: false,
        draggable: false,
      });
      try {
        const response = await ApiService.axiosApi(
          `/schedulemaster/eraseallschedule/${selectedGroupId}`,
          {
            method: "DELETE",
          }
        );
        if (response.success) {
          startProgressBar();
          startSchedulerCheck();
          getChakCount();
        } else {
          toast.error("Failed to delete schedule");
        }
      } catch (e) {
        console.log(e);
      }
    };
   
     const handleWeekdaysChange = (
       rowId: number,
       selected: MultiValue<Option>
     ) => {
       const bitSequence = Array(7)
         .fill(0)
         .map((_, i) => (selected.some((s) => s.value === i) ? 1 : 0))
         .join("");
       const finalSequence = "0" + bitSequence;
   
       updateRow(rowId, "selectedDays", selected as Option[]);
       updateRow(rowId, "weekdaysBit", finalSequence);
     };
   
     const handleValvesChange = (rowId: number, selected: MultiValue<Option>) => {
          console.log(selected)
       // Prepare 8 bits initially all 0
       const bits = Array(14).fill(0);
   
       selected.forEach((s) => {
         const valveNumber = Number(s.value); // 1,2,3,4
         const bitIndex = 14 - valveNumber; // Map V1→7, V2→6, V3→5, V4→4
         bits[bitIndex] = 1;
       });
   
       const bitSequence = bits.join(""); // 8-bit string
   
       updateRow(rowId, "selectedValves", selected as Option[]);
       updateRow(rowId, "valvesBit", bitSequence);

       console.log(`Selected valves: ${selected.map((s) => s.label).join(", ")}`);
       console.log(`Bit string sent to API: ${bitSequence}`);
     };
   
     const getGroupNameForDropdown = async () => {
       try {
         const response = await ApiService.axiosApi(
           `/group`,
           {
             method: "GET",
             params: { pageNumber: 0, pageSize: 0 },
           }
         );
         if (response.success) {
           setGroupData(response.data.data);
          
         }
       } catch (e) {
         console.log(e);
       }
     };
    
     const getSchedule = async () => {
       if (!selectedGroupId) return;
       try {
         const response = await ApiService.axiosApi(
           `/schedulemaster/${selectedGroupId}`,
           { method: "GET",pageNumber:0,pageSize:0 }
         );
         if (response.success) {
           const data = response.data.data || [];
           const filledRows: RowData[] = Array.from({ length: 10 }).map((_, i) => {
             const schNo = i + 1;
             const schedule = data.find((d: any) => d.scheduleNo === schNo);
             if (schedule) {
               return {
                 id: schedule.scheduleId,
                 schno: schNo,
                 enabled: schedule.enable ?? false,
                 startDate: epochToDate(Number(schedule.startDate)),
                 endDate: epochToDate(Number(schedule.endDate)),
                 startTime: schedule.startTime
                   ? new Date(`${new Date().toDateString( )} ${schedule.startTime}`)
                   : null,
                 duration: schedule.duration?.toString() || "",
                 weekdaysBit: decimalToBitString(Number(schedule.weekDays), 8),
   
                 valvesBit: decimalToBitString(
                    Number(schedule.valveNumber),
                    TOTAL_VALVES
                  ) || "0".repeat(TOTAL_VALVES),
                 selectedDays: bitToOptions(
                   decimalToBitString(Number(schedule.weekDays), 8),
                   weekdayOptions
                 ),
                 selectedValves:
                  bitToValve(
                         decimalToBitString(
                           Number(schedule.valveNumber),
                           TOTAL_VALVES
                         ),
                         valveOptions
                       ),
                  volume:schedule.volume  ,
                  totalChakCount: schedule.totalChakCount,   
                  eraseRetry:schedule.eraseRetry
               };
             } else {
               return {
                 schno: schNo,
                 enabled: false,
                 startDate: null,
                 endDate: null,
                 startTime: null,
                 duration: "",
                 weekdaysBit: "0000000",
   
                 selectedDays: [],
   
                 selectedValves: deviceType === "ROMS" ? null : [],
                 valvesBit: deviceType === "ROMS" ? "" : "0".repeat(TOTAL_VALVES),
                 volume:null,
                 totalChakCount:null,
                 eraseRetry:0
               };
             }
           });
           console.log(filledRows)
           setRows(filledRows);
           setModifiedRows([]);
         }
       } catch (e) {
         console.log(e);
       }
     };
   
     useEffect(() => {
       getGroupNameForDropdown();
     }, []);
   
     useEffect(() => {
       getSchedule();
     }, [selectedGroupId]);
   
     
   
     const handleAddSchedule = async (rowId: number) => {
       const row = rows.find((r) => r.schno === rowId);
       if (!row) return;
       const payload = {
         scheduleNo: row.schno,
         enable: row.enabled,
         
         startDate: row.startDate
           ? Math.floor(row.startDate.getTime() / 1000).toString()
           : null,
         endDate: row.endDate ? Math.floor(row.endDate.getTime() / 1000).toString() : null,
         startTime: row.startTime
         ? format(row.startTime, "HH:mm")
         : null,
         duration: row.duration,
         weekDays: row.weekdaysBit,
         valveNumber: row.valvesBit,
   
         groupId: selectedGroupId,
         volume:row.volume
       };
       try {
         const response = await ApiService.axiosApi(
           `/schedulemaster`,
           {
             method: "POST",
             data: payload,
           }
         );
         if (response.success) {
           toast.success(`Schedule ${rowId} updated successfully!`);
           getSchedule();
         } else toast.error(`Failed to update Schedule ${rowId}`);
         // Remove row from modifiedRows after successful update
         setModifiedRows((prev) => prev.filter((r) => r.schno !== rowId));
       } catch (e) {
         console.log(e);
         toast.error(`Failed to update row ${rowId}`);
       }
     };
   
   
   
     const getNodeScheduler = async () => {
       try {
         const response = await ApiService.axiosApi(
           `/schedulenodeupdater/getbygroupinfoid/${selectedGroupId}`,
           {
             method: "GET",
           }
         );
         if (response.success) {
           setNodeScheduler(response.data);
         } else {
           console.log("Unable to get node Schedule");
         }
       } catch (e) {
         console.log(e);
       }
     };
   
     useEffect(() => {
       getNodeScheduler();
     }, [selectedGroupId]);
   
     const handleRetry = (id: number) => {
       console.log(`Retry clicked for Chak ID: ${id}`);
       setNodeScheduler((prev) =>
         prev?.map((c) => (c.id === id ? { ...c, status: "Pending" } : c))
       );
     };
     return (
       <>
         <Breadcrumbs mainTitle="Group Scheduler" parent="Schedule" />
         <Card className="p-2">
           <CommonCardHeader title="Group Scheduler" headClass={"pb-3"} />
   
           {/* Header Dropdown */}
           <div
             className="p-3 d-flex mb-1 bg-light-primary justify-content-between"
             style={{
               cursor: "pointer",
               backgroundColor: "whitesmoke",
               borderRadius: "5px",
             }}
           >
             <div className="d-flex justify-content-start">
               <span>Schedules ({rows?.length})</span>
               <span onClick={() => setCollapsed(!collapsed)}>
                 {collapsed ? "▼" : " ▲"}
               </span>
             </div>

             <div className="d-flex justify-content-end align-items-center" style={{ width: "30%" }}>

              <div className="d-flex" style={{ width: "40%",fontSize:'16px' }}>
              
              {`Scheduled Chaks: (${chakCount?.totalChakCount?chakCount?.totalChakCount:0})`}
           
              </div>
   
             <div className=" mx-4 input-border d-flex" style={{width:'40%'}}>
               <Dropdown
                 isOpen={secondDropdown}
                 toggle={toggleDropdown2}
                 style={{width:'100%'}}
                 color="primary"
               
               >
                 <DropdownToggle
                   className="custom-dropdown-toggle d-flex align-items-center justify-content-between "
                   style={{
                    backgroundColor: "rgb(43, 95, 96)",
                    borderColor: "rgb(43, 95, 96)",
                    color: "#fff",
                    fontWeight: 500,
                    borderRadius: "5px",
                    padding: "8px 16px",
                    width:'100%',
                    height: "36px",
                   }}
                   color="whitesmoke"
                 >
                   {selectedGroup ? selectedGroup : "Group"}
                 </DropdownToggle>
                 <DropdownMenu style={{ overflowY: "auto", borderRadius: "8px" }}>
                   {groupData?.map((data: any) => (
                     <DropdownItem
                       key={data.id}
                       onClick={() => {
                         setSelectedGroup(data.groupName);
                         setSelectedGroupId(data.groupId);
                         setDeviceType(data.deviceType);
                       }}
                     >
                       {data.groupName}
                     </DropdownItem>
                   ))}
                 </DropdownMenu>
               </Dropdown>
               
             </div>
             <div className="d-flex " style={{ width: "20%" }}>
              <Button
                className="px-0"
                color="danger"
                size="md"
                style={{ width: "100%", whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                   }}
                onClick={() => deleteAllSchedule()}
              
              >
                Erase All
              </Button>
            </div>
           </div>
           </div>
   
           {/* Table */}
           {!collapsed && (
             <div className="table-responsive schedule-dark">
               <Table
                 bordered
                 hover
                 responsive
                 className="align-middle text-center  schedule-dark"
               >
                 <thead className="bg-light-primary">
                   <tr>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       #
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       Enable
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       {" "}
                       Start Date
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       End Date
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       Start Time
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       Duration
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       Volume
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       Weekdays
                     </th>
                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       Valves
                     </th>
                     <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Chaks In Schedule
                  </th>

                     <th
                       style={{
                         fontWeight: 600,
                         color: "#333",
                         padding: "6px",
                         fontSize: "1rem",
   
                         height: "50px",
                         overflow: "hidden",
                         textOverflow: "ellipsis",
                         whiteSpace: "nowrap",
                       }}
                     >
                       Action
                     </th>
                   </tr>
                 </thead>
                 <tbody className="schedule-dark">
                 {rows.map((row) => {
                  const retryCount = retryMap[row.id ?? 0] ?? 0;

                  return(
                     <tr
                       key={row.schno}
                       style={{
                         backgroundColor: modifiedRows.some(
                           (m) => m.schno === row.schno
                         )
                           ? "#e6f0ff"
                           : "white",
                       }}
                     >
                       <td className="schedule-dark">{row.schno}</td>
                       <td className="schedule-dark">
                         <Input
                           type="checkbox"
                           checked={row.enabled}
                           onChange={(e) =>
                             updateRow(row.schno, "enabled", e.target.checked)
                           }
                         />
                       </td>
                       <td className="schedule-dark">
                         <DateTimePicker
                           selected={row.startDate}
                           onChange={(d) => updateRow(row.schno, "startDate", d)}
                           className="form-control"
                           dateFormat="dd/MM/yyyy HH:mm:ss"
                           showTimeSelect
                         />
                       </td>
                       <td className="schedule-dark">
                         <DateTimePicker
                           selected={row.endDate}
                           onChange={(d) => updateRow(row.schno, "endDate", d)}
                           className="form-control"
                           dateFormat="dd/MM/yyyy HH:mm:ss"
                           showTimeSelect
                         />
                       </td>
                       <td className="schedule-dark">
                         <DateTimePicker
                           selected={row.startTime}
                           onChange={(d) =>
                             updateRow(
                               row.schno,
                               "startTime",
                               d 
                             )
                           }
                           showTimeSelect
                           showTimeSelectOnly
                           timeIntervals={15}
                           timeCaption="Time"
                           dateFormat="HH:mm"
                           className="form-control"
                         />
                       </td>
                       <td className="schedule-dark">
                         <Input
                           type="number"
                           min={0}
                           value={row.duration}
                           onChange={(e) =>
                             updateRow(row.schno, "duration", e.target.value)
                           }
                         />
                       </td>
                       <td className="schedule-dark">
                         <Input
                           type="text"
                           min={0}
                           value={row.volume?row.volume:''}
                           onChange={(e) =>
                             updateRow(row.schno, "volume", e.target.value)
                           }
                         />
                       </td>
                       <td className="schedule-dark" style={{ minWidth: 180 }}>
                         <Select
                           isMulti
                           options={weekdayOptions}
                           value={row.selectedDays}
                           onChange={(selected) =>
                             handleWeekdaysChange(row.schno, selected)
                           }
                           closeMenuOnSelect={false}
                           components={{ ValueContainer: MultiValueContainer }}
                           placeholder="Select weekdays"
                           styles={{
                             control: (base) => ({
                               ...base,
                               minHeight: "40px",
                               height: "auto",            // 🔑 allow height to grow
                             }),
                             valueContainer: (base) => ({
                               ...base,
                               flexWrap: "wrap",          // 🔑 allow wrapping
                               whiteSpace: "normal",
                               overflow: "visible",
                             }),
                             multiValue: (base) => ({
                               ...base,
                               maxWidth: "100%",
                             }),
                           }}
                         />
                       </td>
                       <td className="schedule-dark" style={{ minWidth: 180 }}>
                         
                           <Select
                             isMulti
                             options={valveOptions}
                             value={row.selectedValves}
                             onChange={(selected) =>
                               handleValvesChange(row.schno, selected)
                             }
                             closeMenuOnSelect={false}
                             components={{ ValueContainer: MultiValueContainer }}
                             placeholder="Select valves"
                           />
                         
                       </td>
                       <td>
                      <span>{row.totalChakCount}</span>
                    </td>

                    <td className="d-flex flex-column align-items-center justify-content-center schedule-dark gap-2">
                      <div className="d-flex justify-content-between schedule-dark ">
                      <Button
                        size="sm"
                        color="primary"
                        disabled={
                          !modifiedRows.some((m) => m.schno === row.schno)
                        }
                        onClick={() => handleAddSchedule(row.schno)}
                        className="me-1  main-button d-flex justify-content-center"
                      >
                        <div style={{ width: "20px", height: "20px" }}>
                          <AddIcon />
                        </div>
                      </Button>
                    <div onClick={
                       () =>{ 
                         
                        if(row.eraseRetry >= 3){
                          toast.warn('maximum limit exceeded try force delete')
                       }
                         
                       }
                    }>
                      <Button
                        size="sm"
                        color="warning"
                        className="me-1  main-button d-flex justify-content-center"
                        disabled={row.eraseRetry >= 3}
                        key={row.id}
                        onClick={() => {
                          deleteSchedule(
                            selectedGroupId ? selectedGroupId : "",
                            row.id ? row.id : ""
                          );
                          setRetryMap(prev => ({
                            ...prev,
                            [row.id!]: (prev[row.id!] ?? 0) + 1
                          }));
                        }}
                      >
                        <div style={{ width: "20px", height: "20px" }}>
                          <DeleteIcon />
                        </div>
                      </Button>
                      </div>
                      </div>
                      <div className="d-flex justify-content-center"
                        onClick={() => {
                          if (row.eraseRetry < 3) {
                            toast.warning("maximum limit exceeded");
                          }
                        }}
                      >
                          <Button className="px-2 d-flex justify-content-center"
                           color="danger"
                           size="md"
                           disabled={row.eraseRetry < 3}
                           onClick={()=>{
                             forceScheduleDelete(row.id?row.id:'')
                           }}
                          >
                            Force Delete
                          </Button>
                      </div>

                      
                    </td>
                     </tr>
                    );
                  })}
                 </tbody>
               </Table>
             </div>
           )}
         </Card>
       </>
     );
   };
   
   export default GroupScheduler;
   